

import { Component, Prop, Vue } from 'vue-property-decorator';
import { form8StatusInfoType } from '@/types/Information/Form8';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form8ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form8StatusInfoType;

}
